"use client";

import React, { useState, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";

const ReloaderPage = ({ onComplete }) => {
  const logoControls = useAnimation();
  const containerControls = useAnimation();
  const [logoError, setLogoError] = useState(false);

  useEffect(() => {
    const run = async () => {
      // Move logo from bottom to center
      await logoControls.start({
        y: "0vh",
        opacity: 1,
        transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
      });

      await new Promise((r) => setTimeout(r, 900));

      // Fade out the whole container
      await containerControls.start({
        opacity: 0,
        transition: { duration: 0.6, ease: "easeInOut" },
      });

      if (onComplete) onComplete();
    };

    run();
  }, [logoControls, containerControls, onComplete]);

  return (
    <motion.div
      animate={containerControls}
      initial={{ opacity: 1 }}
      className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden"
      style={{
        background: "linear-gradient(135deg, #f4f6f9, #e9eef5)",
      }}
    >
      {/* TEXTURE */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `
            repeating-linear-gradient(
              -45deg,
              rgba(15, 105, 157, 0.035) 0px,
              rgba(15, 105, 157, 0.035) 1px,
              transparent 1px,
              transparent 18px
            ),
            repeating-linear-gradient(
              45deg,
              rgba(15, 105, 157, 0.025) 0px,
              rgba(15, 105, 157, 0.025) 1px,
              transparent 1px,
              transparent 28px
            )
          `,
        }}
      />

      {/* GLOW */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at center, rgba(15,105,157,0.08) 0%, transparent 70%)",
        }}
      />

      {/* PARTICLES */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(18)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full"
            style={{
              width: Math.random() * 3 + 2,
              height: Math.random() * 3 + 2,
              background: `rgba(15,105,157,${Math.random() * 0.2})`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{ y: [0, -25, 0], opacity: [0, 0.5, 0] }}
            transition={{
              duration: Math.random() * 3 + 2,
              repeat: Infinity,
              delay: Math.random() * 2,
            }}
          />
        ))}
      </div>

      {/* MAIN LOGO */}
      <motion.div
        animate={logoControls}
        initial={{ y: "60vh", opacity: 0 }}
        className="flex items-center justify-center"
      >
        <div style={{ width: 120, height: 120 }}>
          {!logoError ? (
            <img
              src="/icon.png"
              alt="IEEE Logo"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
              onError={() => setLogoError(true)}
            />
          ) : (
            <div style={{ color: "#0f699d", fontWeight: 300, fontSize: 32 }}>
              IEEE
            </div>
          )}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ReloaderPage;